import { Component, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'button[au-button]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss', '../../../unity/css/em-unity-1.7.1.css'],
  styles: [':host { display: inline-flex}']
})
export class ButtonComponent {

  @Input() buttonStyle: 'default' | 'primary' | 'secondary' | 'tertiary' | 'inverted' | 'invertedRed' | 'dark' = 'default';
  @Input() size: 'small' | 'default' | 'large' = 'default';
  @Input() disabled = false;
  @Input() icon = '';
  @Input() iconSize: 'extraSmall' | 'small' | 'medium' | 'large' = 'small';
  @Input() iconColor = '';
  @Input() text = '';

  @HostBinding('type') @Input() type = 'button' //Default to button, user can change to submit or reset as desired
  @HostBinding('class.transparent-back') @Input() transparentBackground = false; //Makes background and border transparent
  @HostBinding('class.em-c-field__body') @Input() inFieldset = false; //Helps align button correctly if placed in fieldset
  @HostBinding('class.em-button-small-icon')
  @HostBinding('class.em-u-padding-half') @Input() fitIcon = false; //Puts border tight around icon with no padding

  @HostBinding('class.em-c-btn') _btn = true;
  @HostBinding('class.em-c-btn--primary') get _primary(): boolean { return this.buttonStyle === 'primary'; }
  @HostBinding('class.em-c-btn--secondary') get _secondary(): boolean { return this.buttonStyle === 'secondary'; }
  @HostBinding('class.em-c-btn--tertiary') get _tertiary(): boolean { return this.buttonStyle === 'tertiary'; }
  @HostBinding('class.em-c-btn--inverted') get _inverted(): boolean { return this.buttonStyle === 'inverted'; }
  @HostBinding('class.em-c-btn--inverted-red') get _invertedRed(): boolean { return this.buttonStyle === 'invertedRed'; }
  @HostBinding('class.em-button-dark') get _dark(): boolean { return this.buttonStyle === 'dark'; }
  @HostBinding('class.em-c-btn--small') get _small(): boolean { return this.size === 'small'; }
  @HostBinding('class.em-c-btn--large') get _large(): boolean { return this.size === 'large'; }
  @HostBinding('class.em-c-btn--disabled') get _disabledStyle(): boolean { return this.disabled }
  @HostBinding('disabled') get _disabled() { return this.disabled ? true : null }

  // Used internally to set unity js classes when necessary
  @Input() buttonTextClass: string | undefined;

  //For 'selectable', using Unity's em-js-btn-selectable works, but doesn't allow you to bind to the selected state of the button
  //This section provides a two-way binding to 'isSelected' and enables 'selectable', which mirrors the Unity JS functionality through a click listener.
  @Input() selectable = false;
  @HostListener('click') selectableClick() { if (this.selectable) { this.isSelected = !this.isSelected; } }
  @HostBinding('class.em-is-active') _isActive = false;
  @Input()
  get isSelected(): boolean { return this._isActive; }
  set isSelected(val) {
    this._isActive = val;
    this.isSelectedChange.emit(this._isActive);
  }
  @Output() isSelectedChange = new EventEmitter<boolean>();

}
